/* eslint-disable import/prefer-default-export */
import React from 'react';
import { OverlayProvider } from '@saviynt/design-system';

/**
 * Wrapper utility - ensures nav components have OverlayProvider from nav's bundle.
 * This fixes Context isolation in micro-frontend architecture where each bundle
 * has separate React Context instances that can't cross bundle boundaries.
 *
 * Generic name allows other packages to use the same pattern.
 */
export function withOverlayProvider<P>(
  Component: React.ComponentType<P>
): React.ComponentType<P> {
  function WrappedComponent(props: P) {
    return (
      <OverlayProvider>
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        <Component {...(props as P & JSX.IntrinsicAttributes)} />
      </OverlayProvider>
    );
  }

  WrappedComponent.displayName = `withOverlayProvider(${
    Component.displayName ?? Component.name
  })`;

  return WrappedComponent;
}
